import React,{ useState} from 'react';
import '../../css/shared/PdfUpload.css';
import upload from '../../assets/images/upload_enable.svg';
import cross from '../../assets/images/close.svg';
import uploadDisable from '../../assets/images/upload_disable.svg';
import { uploadApiCall } from '../../Services/utils/UploadApiCall';
import { utilityBaseURL } from '../../Services/config/apiGateway';
import { UPLOAD_ENDPOINT } from '../../Services/config/apiEndPoints';
import message from '../../data/Message.json';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function PdfUpload(props){
    const [fileName, setFileName] = useState(props.pdfFileName);
    const [isUploadDisabled, setIsUploadDisabled] = useState(props.isUploadDisabled);
    function anchorClick(e) {
        e.preventDefault();
        document.querySelector('#upload').click();
        let fileupload = document.getElementById("upload");
        fileupload.onchange = function (el) {
            let files = el.target.files[0];
            if (fileupload.value.match(/pdf$/) || fileupload.value.match(/PDF$/)) {
                if (fileupload.files.length > 0) {
                    for (let i = 0; i <= fileupload.files.length - 1; i++) {
                        const fsize = fileupload.files.item(i).size;
                        const file = Math.round((fsize / 1024));
                        // The size of the file. 
                        if (file > 2048) {
                            toast(
                                "File too big, please select a file less than 2MB", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: '120%' } });
                        } else {
                            let fileUploadName = fileupload.value.split('\\')[fileupload.value.split('\\').length - 1];
                            setFileName(fileUploadName);
                            console.log('before update')
                            const reader = new window.FileReader();
                            reader.readAsDataURL(files);
                            reader.onload = (f) => {
                                const newName = el.target.files[0].name.replace(/[&\/\\#,+ ()$~%'":*?<>{}]/g, '');
                                const formData1 = new window.FormData();
                                formData1.append('file', files, newName);
                                console.log("before api call", formData1);
                                uploadApiCall(
                                    'POST',
                                    utilityBaseURL +
                                    UPLOAD_ENDPOINT,
                                    formData1,
                                    {
                                        Accept: 'application/json',
                                        ' x-cc-trace-id': '1234'
                                    },
                                    true,
                                    true
                                ).then((response) => response)
                                    .then((data) => {
                                        console.log("second then", data)
                                        if (data.flag !== -1) {
                                            if (data.flag === 500) {
                                                document.querySelector('#upload').value = null;
                                                toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                                                console.log("in 500 data", data);
                                            }
                                            else {
                                                console.log('I am 200!');
                                                console.log("in 200 data", data);
                                                setIsUploadDisabled(true);
                                                console.log("path", data.documentPath.replace(/\s/g, ''));
                                                props.setImageLink(data.documentPath.replace(/\s/g, ''));
                                                toast("File uploaded successfully", { position: toast.POSITION.TOP_CENTER, style: { color: "black" } });
                                            }
                                        } else {
                                            document.querySelector('#upload').value = null;
                                        }
                                    });
                            }
                        }
                    }
                }
            }
            else { toast("File should be pdf only.", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } }) }
        };
    }
    return (
        <div className="uploadContainer">
            <span style={{ display: isUploadDisabled ? "flex" : "none" }} className="filename">
                <div className="uploadedFilenameimg">
                    <div className="uploadedfilename">{fileName}</div>
                    <img alt=""
                        onClick={() => {
                            document.querySelector('#upload').value = null;
                            setIsUploadDisabled(false);
                            console.log('close requested')
                            props.removeLink()
                        }}
                        src={cross} width="30" height="30"
                    />
                </div>
            </span><hr className="spanhr" style={{ display: isUploadDisabled ? "flex" : "none" }} />
            <div className="upload">
                <div class="uploadsize">
                    <a id="upload_link" style={{ color: isUploadDisabled ? "#C4C4C4" : "#428BCA" }} onClick={anchorClick}>Upload</a>
                    <img src={isUploadDisabled ? uploadDisable : upload} id="uploadicon" alt="" loading="lazy" /> &#160;
            <input id="upload" type="file" class="pdfUploadinput" disabled={isUploadDisabled} />
                </div>
                <div class="filesize">
                    <div>
                        <small class="fileSizeText"> Size : </small>
                        <small class="maxFileSizeText">2 MB (Max.)</small>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PdfUpload;